<template>
  <div class="item-release-detail-container">
    <!-- (1) PageHeader -->
    <ds-page-header :title="$t('itemReleaseDetail.releaseDetails')"
      :subtitle="$t('itemReleaseDetail.page.subtitle')">
      <template #extra>
        <el-button icon="el-icon-back" @click="_goBack">
          {{ $t('itemReleaseDetail.back') }}
        </el-button>
      </template>
    </ds-page-header>

    <!-- (2) 放行详情面板 -->
    <div class="ds-panel">
      <div class="ds-panel__header">
        <span class="ds-panel__title">{{ $t('itemReleaseDetail.releaseDetails') }}</span>
      </div>

      <div class="ds-info-grid" v-if="itemReleaseDetailInfo.pools">
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('itemReleaseDetail.applyCompany') }}</span>
          <span class="ds-info-grid__value">{{ itemReleaseDetailInfo.pools.applyCompany || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('itemReleaseDetail.passType') }}</span>
          <span class="ds-info-grid__value">{{ itemReleaseDetailInfo.pools.typeName || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('itemReleaseDetail.applicant') }}</span>
          <span class="ds-info-grid__value">{{ itemReleaseDetailInfo.pools.applyPerson || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('itemReleaseDetail.idCard') }}</span>
          <span class="ds-info-grid__value">{{ itemReleaseDetailInfo.pools.idCard || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('itemReleaseDetail.phone') }}</span>
          <span class="ds-info-grid__value ds-num">{{ itemReleaseDetailInfo.pools.applyTel || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('itemReleaseDetail.applyTime') }}</span>
          <span class="ds-info-grid__value ds-num">{{ itemReleaseDetailInfo.pools.createTime || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('itemReleaseDetail.status') }}</span>
          <span class="ds-info-grid__value">
            <ds-status-tag :label="itemReleaseDetailInfo.pools.stateName || '-'" :text="itemReleaseDetailInfo.pools.stateName"
              type="info" />
          </span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('itemReleaseDetail.licensePlate') }}</span>
          <span class="ds-info-grid__value ds-num">{{ itemReleaseDetailInfo.pools.carNum || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('itemReleaseDetail.passTime') }}</span>
          <span class="ds-info-grid__value ds-num">{{ itemReleaseDetailInfo.pools.passTime || '-' }}</span>
        </div>
        <div class="ds-info-grid__item">
          <span class="ds-info-grid__label">{{ $t('itemReleaseDetail.totalQuantity') }}</span>
          <span class="ds-info-grid__value ds-num">{{ itemReleaseDetailInfo.pools.amount || 0 }}</span>
        </div>
      </div>
    </div>

    <!-- (3) 放行物品面板 -->
    <div class="ds-panel">
      <div class="ds-panel__header">
        <span class="ds-panel__title">{{ $t('itemReleaseDetail.releaseItems') }}</span>
      </div>
      <ds-data-table :data="itemReleaseDetailInfo.resNames" border
        :empty-description="$t('itemReleaseDetail.page.emptyItems')">
        <el-table-column prop="resName" :label="$t('itemReleaseDetail.itemName')" align="center" />
        <el-table-column prop="amount" :label="$t('itemReleaseDetail.quantity')" align="center">
          <template slot-scope="scope">
            <span class="ds-num">{{ scope.row.amount }}</span>
          </template>
        </el-table-column>
      </ds-data-table>
    </div>

    <!-- (4) 工单流转面板 -->
    <div class="ds-panel">
      <div class="ds-panel__header">
        <span class="ds-panel__title">{{ $t('itemReleaseDetail.workflowProcess') }}</span>
      </div>
      <ds-data-table :data="itemReleaseDetailInfo.comments" border
        :empty-description="$t('itemReleaseDetail.page.emptyFlow')">
        <el-table-column type="index" :label="$t('itemReleaseDetail.serialNumber')" align="center" width="80" />
        <el-table-column prop="orgName" :label="$t('itemReleaseDetail.department')" align="center">
          <template slot-scope="scope">
            {{ scope.row.orgName || $t('itemReleaseDetail.administrator') }}
          </template>
        </el-table-column>
        <el-table-column prop="staffName" :label="$t('itemReleaseDetail.handler')" align="center" />
        <el-table-column :label="$t('itemReleaseDetail.status')" align="center">
          <template slot-scope="scope">
            <ds-status-tag :label="scope.row.endTime
              ? $t('itemReleaseDetail.processed')
              : $t('itemReleaseDetail.processing')"
              :text="scope.row.endTime ? 'done' : 'doing'" :type="scope.row.endTime ? 'success' : 'warning'" />
          </template>
        </el-table-column>
        <el-table-column prop="duration" :label="$t('itemReleaseDetail.timeConsumed')" align="center">
          <template slot-scope="scope">
            <span class="ds-num">{{ scope.row.duration || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="context" :label="$t('itemReleaseDetail.comment')" align="center" />
      </ds-data-table>
    </div>

    <!-- (5) 工单办理面板 -->
    <div class="ds-panel" v-if="itemReleaseDetailInfo.action">
      <div class="ds-panel__header">
        <span class="ds-panel__title">{{ $t('itemReleaseDetail.workOrderProcessing') }}</span>
      </div>
      <div class="ds-panel__body">
        <el-form label-width="150px" label-position="right" class="ds-form">
          <el-form-item :label="$t('itemReleaseDetail.action')">
            <el-select v-model="itemReleaseDetailInfo.audit.auditCode" class="w-full">
              <el-option :label="$t('itemReleaseDetail.pleaseSelect')" value="" disabled />
              <el-option v-if="itemReleaseDetailInfo.nextAudit.next || itemReleaseDetailInfo.nextAudit.exit"
                value="1100" :label="$t('itemReleaseDetail.agree')" />
              <el-option v-if="itemReleaseDetailInfo.nextAudit.back" value="1200"
                :label="$t('itemReleaseDetail.return')" />
              <el-option v-if="itemReleaseDetailInfo.nextAudit.backIndex" value="1400"
                :label="$t('itemReleaseDetail.returnToSubmitter')" />
              <el-option value="1300" :label="$t('itemReleaseDetail.transfer')" />
              <!--&& userId == itemReleaseDetailInfo.pools.createUserId-->
              <el-option v-if="itemReleaseDetailInfo.nextAudit.exit" value="1500" :label="$t('itemReleaseDetail.end')" />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('itemReleaseDetail.workOrderDescription')">
            <el-input type="textarea" :placeholder="$t('itemReleaseDetail.requiredDescription')"
              v-model="itemReleaseDetailInfo.audit.auditMessage" />
          </el-form-item>
          <!-- 下一处理人 -->
          <el-form-item
            v-if="(itemReleaseDetailInfo.audit.auditCode == '1100' && itemReleaseDetailInfo.nextAudit.assignee == '-2') ||
              itemReleaseDetailInfo.audit.auditCode == '1300'" :label="$t('itemReleaseDetail.nextHandler')">
            <div class="ds-inline-field">
              <el-input v-model="itemReleaseDetailInfo.audit.staffName" class="ds-inline-field__input"
                :placeholder="$t('itemReleaseDetail.requiredNextHandler')" disabled />
              <el-button class="ds-inline-field__suffix" @click="chooseStaff">{{ $t('itemReleaseDetail.select') }}</el-button>
            </div>
          </el-form-item>

          <!-- 表单操作区 -->
          <div class="ds-form-actions">
            <el-button type="primary" icon="el-icon-check" @click="_auditSubmit">
              {{ $t('itemReleaseDetail.submit') }}
            </el-button>
          </div>
        </el-form>
      </div>
    </div>

    <!-- (6) 流程图面板 -->
    <div class="ds-panel">
      <div class="ds-panel__header">
        <span class="ds-panel__title">{{ $t('itemReleaseDetail.flowChart') }}</span>
      </div>
      <div class="ds-panel__body text-center">
        <img v-if="itemReleaseDetailInfo.imgData" :src="itemReleaseDetailInfo.imgData" alt="" class="flow-chart">
      </div>
    </div>

    <!-- 选择员工组件 -->
    <select-staff ref="selectStaff" @selectStaff="handleStaffSelect" />
  </div>
</template>

<script>
import { getCommunityId } from '@/api/community/communityApi'
import SelectStaff from '@/components/staff/SelectStaff'
import {
  listItemReleaseRes,
  listItemRelease,
  auditUndoItemRelease,
  queryOaWorkflowUser,
  listRunWorkflowImage,
  queryNextDealUser
} from '@/api/work/itemReleaseDetailApi'
import { getUserId } from '@/api/user/userApi'
import DsPageHeader from '@/components/ds/ds-page-header.vue'
import DsDataTable from '@/components/ds/ds-data-table.vue'
import DsStatusTag from '@/components/ds/ds-status-tag.vue'

export default {
  name: 'ItemReleaseDetailList',
  components: {
    SelectStaff,
    DsPageHeader,
    DsDataTable,
    DsStatusTag
  },
  data() {
    return {
      communityId: '',
      userId: '',
      itemReleaseDetailInfo: {
        irId: '',
        flowId: '',
        pools: {},
        resNames: [],
        comments: [],
        action: '',

        audit: {
          auditCode: '1100',
          auditMessage: '',
          staffId: '',
          staffName: '',
          taskId: ''
        },
        imgData: '',
        nextAudit: {},
        files: []
      }
    }
  },
  created() {
    this.communityId = getCommunityId()
    this.userId = getUserId()
    this.initData()
  },
  methods: {
    initData() {
      const irId = this.$route.query.irId
      if (!irId) {
        this.$message.error(this.$t('itemReleaseDetail.illegalOperation'))
        return
      }
      this.itemReleaseDetailInfo.irId = irId
      this.itemReleaseDetailInfo.flowId = this.$route.query.flowId
      this.itemReleaseDetailInfo.action = this.$route.query.action
      this.itemReleaseDetailInfo.audit.taskId = this.$route.query.taskId

      this._listOaWorkflowDetails()
      this._loadItemReleaseRes()
      this._loadComments()
      this._openNewOaWorkflowDetailImg()
    },
    async _loadItemReleaseRes() {
      try {
        const { data } = await listItemReleaseRes({
          page: 1,
          row: 500,
          communityId: this.communityId,
          irId: this.itemReleaseDetailInfo.irId
        })
        this.itemReleaseDetailInfo.resNames = data
      } catch (error) {
        console.error('获取放行物品失败:', error)
      }
    },
    async _listOaWorkflowDetails() {
      try {
        const { data } = await listItemRelease({
          page: 1,
          row: 1,
          irId: this.itemReleaseDetailInfo.irId,
          flowId: this.itemReleaseDetailInfo.flowId,
          communityId: this.communityId
        })
        this.itemReleaseDetailInfo.pools = data[0]
        if (this.itemReleaseDetailInfo.action) {
          this._loadNextAuditPerson()
        }
      } catch (error) {
        console.error('获取放行详情失败:', error)
      }
    },
    async _loadComments() {
      // TODO: 需要实现工单评论接口
      console.log('加载评论')
      const { data } = await queryOaWorkflowUser({
        page: 1,
        row: 50,
        flowId: this.itemReleaseDetailInfo.flowId,
        id: this.itemReleaseDetailInfo.irId,
        communityId: this.communityId
      })
      this.itemReleaseDetailInfo.comments = data
    },
    _goBack() {
      this.$router.go(-1)
    },
    chooseStaff() {
      this.$refs.selectStaff.open(this.itemReleaseDetailInfo.audit)
    },
    async _auditSubmit() {
      const _audit = this.itemReleaseDetailInfo.audit
      _audit.flowId = this.itemReleaseDetailInfo.flowId
      _audit.irId = this.itemReleaseDetailInfo.irId

      if (this.itemReleaseDetailInfo.nextAudit.assignee != '-2' && this.itemReleaseDetailInfo.nextAudit.assignee != '-1') {
        _audit.staffId = this.itemReleaseDetailInfo.nextAudit.assignee
      }

      if (!_audit.auditCode) {
        this.$message.error(this.$t('itemReleaseDetail.selectStatus'))
        return
      }
      if (!_audit.auditMessage) {
        this.$message.error(this.$t('itemReleaseDetail.fillDescription'))
        return
      }
      // if (_audit.auditCode != '1200' && _audit.auditCode != '1400' && !_audit.staffId) {
      //   this.$message.error(this.$t('itemReleaseDetail.selectNextHandler'))
      //   return
      // }

      try {
        await auditUndoItemRelease(_audit)
        this.$message.success(this.$t('common.operationSuccess'))
        this._goBack()
      } catch (error) {
        this.$message.error(error.message || this.$t('itemReleaseDetail.submitFailed'))
      }
    },
    async _loadNextAuditPerson() {
      // TODO: 需要实现获取下一处理人接口
      console.log('加载下一处理人')
      const { data } = await queryNextDealUser({
        startUserId: this.itemReleaseDetailInfo.pools.createUserId,
        taskId: this.itemReleaseDetailInfo.audit.taskId,
        communityId: this.communityId
      })
      this.itemReleaseDetailInfo.nextAudit = data[0]
    },
    async _openNewOaWorkflowDetailImg() {
      const { data } = await listRunWorkflowImage({
        businessKey: this.itemReleaseDetailInfo.irId,
        communityId: this.communityId
      })
      this.itemReleaseDetailInfo.imgData = 'data:image/png;base64,' + data
    },
    handleStaffSelect(staff) {
      this.itemReleaseDetailInfo.audit.staffId = staff.staffId
      this.itemReleaseDetailInfo.audit.staffName = staff.staffName
    }
  }
}
</script>

<style lang="scss" scoped>
.item-release-detail-container {
  padding: var(--ds-spacing-lg);
  background-color: var(--ds-gray-100);
  min-height: calc(100vh - 60px);
}

/* 白色面板 */
.ds-panel {
  background: #fff;
  border: 1px solid var(--ds-gray-300);
  border-radius: var(--ds-radius-md);
  box-shadow: var(--ds-shadow-sm);
  overflow: hidden;
  margin-bottom: var(--ds-spacing-md);

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: var(--ds-spacing-sm) var(--ds-spacing-lg);
    border-bottom: 1px solid var(--ds-gray-200);
  }

  &__title {
    font-size: var(--ds-font-size-lg);
    font-weight: 600;
    color: var(--ds-gray-800);
  }

  &__body {
    padding: var(--ds-spacing-lg);
  }
}

/* 信息栅格 */
.ds-info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: var(--ds-spacing-md) var(--ds-spacing-lg);
  padding: var(--ds-spacing-lg);

  &__item {
    display: flex;
    align-items: baseline;
    gap: var(--ds-spacing-sm);
    min-width: 0;
  }

  &__label {
    flex-shrink: 0;
    font-size: var(--ds-font-size-sm);
    color: var(--ds-gray-500);
  }

  &__value {
    font-size: var(--ds-font-size-sm);
    color: var(--ds-gray-900);
    word-break: break-all;
  }
}

/* 表单 */
.ds-form {
  .el-form-item {
    margin-bottom: var(--ds-spacing-lg);
  }
}

/* 输入框 + 后缀按钮 */
.ds-inline-field {
  display: flex;
  align-items: center;
  gap: var(--ds-spacing-sm);

  &__input {
    flex: 1 1 auto;
  }

  &__suffix {
    flex-shrink: 0;
  }
}

/* 表单操作区 */
.ds-form-actions {
  display: flex;
  justify-content: flex-end;
  gap: var(--ds-spacing-sm);
  padding-top: var(--ds-spacing-md);
  border-top: 1px solid var(--ds-gray-200);
}

.text-center {
  text-align: center;
}

.flow-chart {
  height: 300px;
}
</style>
